import { navigateAction } from 'fluxible-router';
import ApplicationStore from '../stores/ApplicationStore';
import getQuickstartUrl from '../util/getQuickstartUrl';
export default function navigateToQuickstart(context, payload, done) {
    var quickstartId = payload.quickstartId, platformId = payload.platformId, versionId = payload.versionId, articleId = payload.articleId;
    var appStore = context.getStore(ApplicationStore);
    var url = getQuickstartUrl({ quickstartId: quickstartId, platformId: platformId, versionId: versionId, articleId: articleId }, appStore.isFramedMode(), appStore.isSingleQuickstartMode());
    return navigateAction(context, { url: url }, done);
}
